<template>
    <div class="obj-list wrapper">
        <div class="page__card">
            <div class="page__card-title">
                <h1>{{ $t('buildings') }}</h1>
                <div v-if="role" class="page__card-item">
                    <router-link to="/building-list/newcadaster" tag="button" class="page__card-router"
                        active-class="page__card-router--active">
                        <div>
                            <IconNumberSymbol class="router__icon"/>
                        </div>
                        <p class="router__text">
                            {{ $t('change_cadaster_buildings') }}
                        </p>
                    </router-link>
                    <router-link to="/building-list/exg" tag="button"
                        v-if="role != 'ministry' && role !== 'ministry_admin' " class="page__card-router"
                        active-class="page__card-router--active">
                        <div>
                            <IconBuilding1 class="router__icon"/>
                        </div>
                        <p class="router__text">
                            {{ $t('existing_buildings_structures') }}
                        </p>
                    </router-link>
                    <router-link to="/building-list/new" tag="button" class="page__card-router"
                        active-class="page__card-router--active">
                        <div>
                            <IconBuilding4 class="router__icon"/>
                        </div>
                        <p class="router__text">
                            {{ $t('new_buildings_structures') }}
                        </p>
                    </router-link>
                </div>
            </div>
            <AllBuilding />
        </div>
    </div>
</template>

<script>
import AllBuilding from  '@/components/AllBuilding.vue'
import IconNumberSymbol from '../../components/Icons/iconNumberSymbol.vue';
import IconBuilding1 from '../../components/Icons/iconBuilding1.vue';
import IconBuilding4 from '../../components/Icons/iconBuilding4.vue';
 export default {
    components: {
        AllBuilding,
        IconNumberSymbol,
        IconBuilding1,
        IconBuilding4
     },
     data() {
         return {

         };
     },

     computed: {
         role() {
            return this.$store.state.role;
         },
     },
     mounted(){

     }


 };
</script>
<style lang="scss" scoped>
.ctatic-header {
    padding-bottom: 30px;
    padding-top: 20px;

} 

.page__card-item{
    display: flex;
    flex-wrap: wrap;
    gap: 2px;
}
.page__card-router{
    padding: 8px 16px;
    border-radius: 12px;
    transition: all 0.3s ease;
    color: #1E293B;
    display: flex;
    align-items: center;
    gap: 8px;
    .router__text{
        font-weight: 600;
        line-height: 22px;
    }
    .router__icon{
        color: #0891B2;
        width: 24px;
        height: 24px;
    }
    &:hover{
        background: #F1F5F9;
    }
    &--active{
        background: #3730A3;
        color: white;
        &:hover{
            background: #4338CA;
        }
        .router__icon {
            color: white;
        }
    }
    @media screen and (max-width: 575px) {
        padding: 6px 10px;
        width: 100%;
        .router__text{
            font-size: 14px;
            line-height: 1.375;
            text-align: start;
        }
    }
}
</style>
